var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSovcomId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.19995 12C1.19995 14.9174 2.35862 17.7153 4.42107 19.7782C6.48351 21.8411 9.28079 23 12.1975 23C12.3445 23 12.4915 23 12.6385 23V18.8176H12.1975C10.4167 18.7762 8.72275 18.0396 7.47789 16.7652C6.23302 15.4908 5.53607 13.7799 5.53607 11.9982C5.53607 10.2165 6.23302 8.5055 7.47789 7.23111C8.72275 5.95673 10.4167 5.2201 12.1975 5.17875H12.6385V1C12.4915 1 12.3445 1 12.1975 1C9.28079 1 6.48351 2.15893 4.42107 4.22183C2.35862 6.28473 1.19995 9.08262 1.19995 12",
    fill: "#FF4B5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3934 1.21979V6.93846H12.1887C11.513 6.92025 10.8406 7.03763 10.211 7.28367C9.58141 7.52972 9.0075 7.89944 8.52316 8.37101C8.03881 8.84258 7.65384 9.40644 7.39097 10.0293C7.12811 10.6521 6.99268 11.3214 6.99268 11.9974C6.99268 12.6735 7.12811 13.3427 7.39097 13.9656C7.65384 14.5884 8.03881 15.1523 8.52316 15.6239C9.0075 16.0954 9.58141 16.4652 10.211 16.7112C10.8406 16.9572 11.513 17.0746 12.1887 17.0564H14.3934V22.7788C16.8789 22.2733 19.1134 20.9241 20.7183 18.9596C22.3232 16.9952 23.1999 14.5362 23.1999 11.9993C23.1999 9.46234 22.3232 7.00338 20.7183 5.03891C19.1134 3.07443 16.8789 1.72522 14.3934 1.21979Z",
    fill: "#003790"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSovcomId);
export default __webpack_public_path__ + "static/media/sovcom-id.beb8343b0999c569f9011caef1e9d4e4.svg";
export { ForwardRef as ReactComponent };